import { Provider } from 'react-redux';
import { store } from '../state';
import { Main } from './pages';
import './styles/App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { unregister } from '../serviceWorkerRegistration';
import { Amplify } from 'aws-amplify';
import config from '../amplifyconfiguration.json';
import '@aws-amplify/ui-react/styles.css';
import { Authenticator } from '@aws-amplify/ui-react';
import { IntercomProvider } from 'react-use-intercom';
import { AwsRum, AwsRumConfig } from 'aws-rum-web';

const APP_ID = process.env.REACT_APP_RUM_APP_ID ?? '';
const COGNITO_POOL_ID = process.env.REACT_APP_RUM_COGNITO_POOL_ID ?? '';
const GUEST_ROLE = process.env.REACT_APP_RUM_GUEST_ROLE ?? '';

let awsRum = null;
try {
  const config: AwsRumConfig = {
    sessionSampleRate: 1,
    guestRoleArn: GUEST_ROLE,
    identityPoolId: COGNITO_POOL_ID,
    endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
    telemetries: ['performance', 'errors', 'http'],
    allowCookies: true,
    enableXRay: true,
  };

  const APPLICATION_ID: string = APP_ID;
  const APPLICATION_VERSION: string = '1.0.0';
  const APPLICATION_REGION: string = 'us-east-1';

  awsRum = new AwsRum(
    APPLICATION_ID,
    APPLICATION_VERSION,
    APPLICATION_REGION,
    config
  );
} catch (error) {
  console.error('Error initializing CloudWatch RUM web client', error);
  // Ignore errors thrown during CloudWatch RUM web client initialization
}
Amplify.configure(config);

const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID ?? '';
unregister();

function App() {
  return (
    <IntercomProvider appId={INTERCOM_APP_ID} autoBoot>
      <Provider store={store}>
        <Authenticator.Provider>
          <Main />
        </Authenticator.Provider>
      </Provider>
    </IntercomProvider>
  );
}

export default App;
